// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22white%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  --menuBackgroundRGBA: 249, 249, 250;
  --menuBoxShadow: #0000;
  --colorSwitcher: #222B3F;
  --borderColor: #222b3f;
  --buttonColor: #5F40E5;
  --darkColorTransparent: #2a2a2a;
  --darkColor: #0A1730;
  --darkFontColor: #b4aebc;
  --lightColor: #192843;
  --lightColor50: #19284350;
  --lightFontColor: #ffffff;
  --sidebarFontColor: #C9C9CB;
  --sidebarBorder: #222B3F;
  --thinColor: #989ba0;
  --invoiceButton: #ffffff;
  --inputBorder: #222B3F;
  --inputBorderHover: #3F4A60;
  --inputBorderFocus: #613BEA;
  --checkbox-border: #3F4A60;
  --htmlBack: var(--darkColor);
  --purpleColor: #613bea;
  --gridLine: #313131;
  --textWhite: white;
  --selectArrow: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --menuBackgroundHover: rgba(var(--menuBackgroundRGBA), 10%);
  background-color: var(--darkColor) !important;
}

html {
  --menuBackgroundRGBA: 000, 000, 000;
  --borderColorRGBA: 95, 64, 229;
  --menuBoxShadow: #dee2e6;
  --colorSwitcher: #e8e8e8;
  --borderColor: #e8e8e8;
  --buttonColor: #5F40E5;
  --darkColor: #ffffff;
  --darkFontColor: #0A1730;
  --lightColor: #f5f5f5;
  --lightFontColor: #3f4a60;
  --sidebarFontColor: #3f4a60;
  --sidebarBorder: #ffffff;
  --thinColor: #989ba0;
  --invoiceButton: #613BEA;
  --inputBorder: #c9c9cb;
  --inputBorderHover: #E5DFFA;
  --inputBorderFocus: #5F40E5;
  --checkbox-border: #989BA0;
  --htmlBack: #ffffff;
  --purpleColor: #6a3ce2;
  --gridLine: #e0e0e0;
  --textWhite: #222326;
  --pinkColor: #FC618F;
  --selectArrow: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  --menuBackgroundHover: rgba(var(--borderColorRGBA), 10%);
  background-color: var(--darkColor) !important;
}

.dark .modal-icon.success {
  background: var(--green0);
}
.dark .modal-icon.error {
  background: var(--red0);
}
.dark .modal-icon.info {
  background: var(--purple0);
}
.dark .modal-footer button.warning {
  color: var(--black9);
}
.dark .modal-footer button.secondary {
  background: var(--black1);
}

.modal {
  width: 100%;
  max-width: 640px;
  padding: 0;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: var(--white);
  border-radius: 0.5rem;
  position: absolute;
  max-height: 90vh;
  overflow: auto;
  border: 1px solid var(--black1);
  outline: none;
}
.modal-item-text {
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
  background: var(--black1);
  padding: 1rem;
  border-radius: 0.5rem;
}
.modal-container {
  padding: 1.75rem;
}
.modal:hover {
  outline: none;
}
.modal.visible {
  overflow: visible;
}
@media (max-width: 768px) {
  .modal {
    width: calc(100% - 2rem);
    transform: translate(-50%, 0%);
    top: 1rem;
  }
}
.modal.confirm {
  max-width: 400px;
  overflow: hidden;
}
.modal-icon {
  width: 3rem;
  min-width: 3rem;
  height: 3rem;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-bottom: 1.5rem;
}
.modal-icon.success {
  background: var(--green1);
}
.modal-icon.error {
  background: var(--red1);
}
.modal-icon.info {
  background: var(--purple1);
}
.modal-header {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: var(--black9);
  margin-bottom: 0.5rem;
  padding: 0;
  border: 0;
  display: flex;
  justify-content: center;
}
.modal-description {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  color: var(--black5);
}
.modal-description b {
  font-weight: 600;
}
.modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  border-top: none;
  margin-top: 1.75rem;
  padding: 0;
  gap: 1rem;
}
.modal-footer button {
  margin: 0;
  min-height: 2.25rem;
  width: calc(50% - 0.25rem);
  border-radius: 0.5rem;
  border: 1px solid var(--black2);
  box-shadow: 0 1px 2px rgba(18, 20, 23, 0.06);
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
}
.modal-footer button.warning {
  background: var(--red6);
  border-color: var(--red6);
}
.modal-footer button.white {
  font-weight: 500;
  color: var(--black9);
  background: var(--white);
}
.modal .paylixecommerce-text {
  color: var(--black6);
}
.modal .paylixecommerce-text h1 {
  font-size: 1.6rem;
  line-height: 3rem;
}
.modal .paylixecommerce-text h2 {
  font-size: 1.4rem;
  line-height: 2.5rem;
}
.modal .paylixecommerce-text h3 {
  font-size: 1.3rem;
  line-height: 2.4rem;
}
.modal .paylixecommerce-text h4 {
  font-size: 1.1rem;
  line-height: 2rem;
}
.modal .paylixecommerce-text h6 {
  font-weight: 500;
}
.modal .paylixecommerce-text p {
  font-size: 0.9rem;
  margin: 0;
  line-height: 1.2rem;
  margin-bottom: 0.6rem;
  color: var(--black6);
}
.modal .paylixecommerce-text input[type=checkbox] {
  width: 30px;
  height: 20px;
  cursor: pointer;
  font-size: 21px;
  visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem -2rem;
  transform: scale(1.25);
}
.modal .paylixecommerce-text input[type=checkbox]:after {
  content: " ";
  background-color: #fff;
  display: inline-block;
  margin-left: 10px;
  padding-bottom: 5px;
  color: #221d3e;
  width: 17px;
  height: 17px;
  visibility: visible;
  border: 2px solid #181432;
  padding-left: 3px;
  border-radius: 5px;
}
.modal .paylixecommerce-text input[type=checkbox]:checked:after {
  content: "x";
  font-weight: bold;
  font-size: 0.8rem;
  color: #181432;
  position: relative;
  padding-bottom: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: left;
  cursor: pointer;
}
.modal .paylixecommerce-text pre {
  padding: 1rem;
  border-radius: 3px;
  margin-top: 1rem;
  overflow: auto;
  display: block;
  line-height: 1rem;
}
.modal .paylixecommerce-text ul, .modal .paylixecommerce-text ol {
  line-height: 1.5rem;
  padding-left: 1.5rem;
}
.modal .paylixecommerce-text img {
  max-width: 100%;
  border-radius: 5px;
}

.paylixecommerce-overlay {
  backdrop-filter: blur(2px);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999999999;
  background-color: rgba(3, 10, 22, 0.768627451) !important;
}
.paylixecommerce-overlay.unsaved-overlay {
  z-index: 9999999999;
}`, "",{"version":3,"sources":["webpack://./client/assets/variables-dark.scss","webpack://./client/components/modal/new-modal.scss","webpack://./client/assets/variables-light.scss"],"names":[],"mappings":"AAAA;EACE,mCAAA;EAEA,sBAAA;EACA,wBAAA;EAEA,sBAAA;EACA,sBAAA;EAEA,+BAAA;EAEA,oBAAA;EACA,wBAAA;EAEA,qBAAA;EACA,yBAAA;EACA,yBAAA;EAEA,2BAAA;EACA,wBAAA;EAEA,oBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,2BAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;EAGA,sBAAA;EACA,mBAAA;EACA,kBAAA;EAGA,sDAAA;EAEA,2DAAA;EAEA,6CAAA;ACbF;;AC3BA;EACE,mCAAA;EACA,8BAAA;EAEA,wBAAA;EACA,wBAAA;EAEA,sBAAA;EACA,sBAAA;EAEA,oBAAA;EACA,wBAAA;EAEA,qBAAA;EACA,yBAAA;EAEA,2BAAA;EACA,wBAAA;EAGA,oBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,2BAAA;EACA,2BAAA;EAEA,0BAAA;EAEA,mBAAA;EAEA,sBAAA;EACA,mBAAA;EACA,oBAAA;EAEA,oBAAA;EAGA,sDAAA;EAEA,wDAAA;EAEA,6CAAA;ADcF;;AAlDM;EACE,yBAAA;AAqDR;AAlDM;EACE,uBAAA;AAoDR;AAjDM;EACE,0BAAA;AAmDR;AA9CM;EACE,oBAAA;AAgDR;AA9CM;EACE,yBAAA;AAgDR;;AA1CA;EACE,WAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,+BAAA;EACA,aAAA;AA6CF;AA3CE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,qBAAA;AA6CJ;AA1CE;EACE,gBAAA;AA4CJ;AAzCE;EACE,aAAA;AA2CJ;AAxCE;EACE,iBAAA;AA0CJ;AAvCE;EAtCF;IAuCI,wBAAA;IACA,8BAAA;IACA,SAAA;EA0CF;AACF;AAxCE;EACE,gBAAA;EACA,gBAAA;AA0CJ;AAvCE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;AAyCJ;AAvCI;EACE,yBAAA;AAyCN;AAtCI;EACE,uBAAA;AAwCN;AArCI;EACE,0BAAA;AAuCN;AAnCE;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AAqCJ;AAlCE;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AAoCJ;AAlCI;EACE,gBAAA;AAoCN;AAhCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;AAkCJ;AAhCI;EACE,SAAA;EACA,mBAAA;EACA,0BAAA;EACA,qBAAA;EACA,+BAAA;EACA,4CAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAkCN;AAhCM;EACE,uBAAA;EACA,yBAAA;AAkCR;AAhCM;EACE,gBAAA;EACA,oBAAA;EACA,wBAAA;AAkCR;AA7BE;EACE,oBAAA;AA+BJ;AA7BI;EACE,iBAAA;EACA,iBAAA;AA+BN;AA7BI;EACE,iBAAA;EACA,mBAAA;AA+BN;AA7BI;EACE,iBAAA;EACA,mBAAA;AA+BN;AA7BI;EACE,iBAAA;EACA,iBAAA;AA+BN;AA7BI;EACE,gBAAA;AA+BN;AA5BI;EACE,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;AA8BN;AA3BI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;AA6BN;AA3BM;EACE,YAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AA6BR;AA1BM;EACE,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AA4BR;AAxBI;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;AA0BN;AAvBI;EACE,mBAAA;EACA,oBAAA;AAyBN;AAlBI;EACE,eAAA;EACA,kBAAA;AAoBN;;AAfA;EACE,0BAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,yDAAA;AAkBF;AAhBE;EACE,mBAAA;AAkBJ","sourcesContent":["html {\n  --menuBackgroundRGBA: 249, 249, 250;\n\n  --menuBoxShadow: #0000;\n  --colorSwitcher: #222B3F;\n\n  --borderColor: #222b3f;\n  --buttonColor: #5F40E5;\n\n  --darkColorTransparent: #2a2a2a;\n\n  --darkColor: #0A1730;\n  --darkFontColor: #b4aebc;\n\n  --lightColor: #192843;\n  --lightColor50: #19284350;\n  --lightFontColor: #ffffff;\n\n  --sidebarFontColor: #C9C9CB;\n  --sidebarBorder: #222B3F;\n\n  --thinColor: #989ba0;\n\n  --invoiceButton: #ffffff;\n  --inputBorder: #222B3F;\n  --inputBorderHover: #3F4A60;\n  --inputBorderFocus: #613BEA;\n  --checkbox-border: #3F4A60;\n  --htmlBack: var(--darkColor);\n\n\n  --purpleColor: #613bea;\n  --gridLine: #313131;\n  --textWhite: white;\n\n\n  --selectArrow: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22white%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');\n\n  --menuBackgroundHover: rgba(var(--menuBackgroundRGBA), 10%);\n\n  background-color: var(--darkColor) !important;\n}\n\n","@import \"../../assets/variables-dark\";\n@import \"../../assets/variables-light\";\n\n.dark {\n  .modal {\n    &-icon {\n      &.success {\n        background: var(--green0);\n      }\n\n      &.error {\n        background: var(--red0);\n      }\n\n      &.info {\n        background: var(--purple0);\n      }\n    }\n\n    &-footer {\n      button.warning {\n        color: var(--black9);\n      }\n      button.secondary {\n        background: var(--black1);\n      }\n    }\n  }\n}\n\n.modal {\n  width: 100%;\n  max-width: 640px;\n  padding: 0;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  background: var(--white);\n  border-radius: .5rem;\n  position: absolute;\n  max-height: 90vh;\n  overflow: auto;\n  border: 1px solid var(--black1);\n  outline: none;\n\n  &-item-text {\n    font-size: 1rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 1rem;\n    background: var(--black1);\n    padding: 1rem;\n    border-radius: 0.5rem;\n  }\n\n  &-container {\n    padding: 1.75rem;\n  }\n\n  &:hover {\n    outline: none;\n  }\n\n  &.visible {\n    overflow: visible;\n  }\n\n  @media (max-width: 768px) {\n    width: calc(100% - 2rem);\n    transform: translate(-50%, 0%);\n    top: 1rem;\n  }\n\n  &.confirm {\n    max-width: 400px;\n    overflow: hidden;\n  }\n\n  &-icon {\n    width: 3rem;\n    min-width: 3rem;\n    height: 3rem;\n    border-radius: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n    margin-bottom: 1.5rem;\n\n    &.success {\n      background: var(--green1);\n    }\n\n    &.error {\n      background: var(--red1);\n    }\n\n    &.info {\n      background: var(--purple1);\n    }\n  }\n\n  &-header {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 19px;\n    color: var(--black9);\n    margin-bottom: .5rem;\n    padding: 0;\n    border: 0;\n    display: flex;\n    justify-content: center;\n  }\n\n  &-description {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 18px;\n    text-align: center;\n    color: var(--black5);\n\n    b {\n      font-weight: 600;\n    }\n  }\n\n  &-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: nowrap;\n    border-top: none;\n    margin-top: 1.75rem;\n    padding: 0;\n    gap: 1rem;\n\n    button {\n      margin: 0;\n      min-height: 2.25rem;\n      width: calc(50% - .25rem);\n      border-radius: .5rem;\n      border: 1px solid var(--black2);\n      box-shadow: 0 1px 2px rgba(18, 20, 23, 0.06);\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 17px;\n      text-align: center;\n\n      &.warning {\n        background: var(--red6);\n        border-color: var(--red6);\n      }\n      &.white {\n        font-weight: 500;\n        color: var(--black9);\n        background: var(--white);\n      }\n    }\n  }\n\n  .paylixecommerce-text {\n    color: var(--black6);\n\n    h1 {\n      font-size: 1.6rem;\n      line-height: 3rem;\n    }\n    h2 {\n      font-size: 1.4rem;\n      line-height: 2.5rem;\n    }\n    h3 {\n      font-size: 1.3rem;\n      line-height: 2.4rem;\n    }\n    h4 {\n      font-size: 1.1rem;\n      line-height: 2rem;\n    }\n    h6 {\n      font-weight: 500;\n    }\n\n    p {\n      font-size: .9rem;\n      margin: 0;\n      line-height: 1.2rem;\n      margin-bottom: .6rem;\n      color: var(--black6);\n    }\n\n    input[type=checkbox] {\n      width: 30px;\n      height: 20px;\n      cursor: pointer;\n      font-size: 21px;\n      visibility: hidden;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin: 1rem -2rem;\n      transform: scale(1.25);\n\n      &:after {\n        content: \" \";\n        background-color: #fff;\n        display: inline-block;\n        margin-left: 10px;\n        padding-bottom: 5px;\n        color: #221d3e;\n        width: 17px;\n        height: 17px;\n        visibility: visible;\n        border: 2px solid #181432;\n        padding-left: 3px;\n        border-radius: 5px;\n      }\n\n      &:checked:after {\n        content: \"x\";\n        font-weight: bold;\n        font-size: .8rem;\n        color: #181432;\n        position: relative;\n        padding-bottom: 0;\n        text-align: center;\n        display: flex;\n        align-items: center;\n        justify-content: left;\n        cursor: pointer;\n      }\n    }\n\n    pre {\n      padding: 1rem;\n      border-radius: 3px;\n      margin-top: 1rem;\n      overflow: auto;\n      display: block;\n      line-height: 1rem;\n    }\n\n    ul, ol {\n      line-height: 1.5rem;\n      padding-left: 1.5rem;\n\n      li {\n\n      }\n    }\n\n    img {\n      max-width: 100%;\n      border-radius: 5px;\n    }\n  }\n}\n\n.paylixecommerce-overlay {\n  backdrop-filter: blur(2px);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999999999;\n  background-color: #030a16c4 !important;\n\n  &.unsaved-overlay {\n    z-index: 9999999999;\n  }\n}","html {\n  --menuBackgroundRGBA: 000, 000, 000;\n  --borderColorRGBA: 95, 64, 229;\n\n  --menuBoxShadow: #dee2e6;\n  --colorSwitcher: #e8e8e8;\n\n  --borderColor: #e8e8e8;\n  --buttonColor: #5F40E5;\n\n  --darkColor: #ffffff;\n  --darkFontColor: #0A1730;\n\n  --lightColor: #f5f5f5;\n  --lightFontColor: #3f4a60;\n\n  --sidebarFontColor: #3f4a60;\n  --sidebarBorder: #ffffff;\n\n\n  --thinColor: #989ba0;\n\n  --invoiceButton: #613BEA;\n  --inputBorder: #c9c9cb;\n  --inputBorderHover: #E5DFFA;\n  --inputBorderFocus: #5F40E5;\n\n  --checkbox-border: #989BA0;\n\n  --htmlBack: #ffffff;\n\n  --purpleColor: #6a3ce2;\n  --gridLine: #e0e0e0;\n  --textWhite: #222326;\n\n  --pinkColor: #FC618F;\n\n\n  --selectArrow: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');\n\n  --menuBackgroundHover: rgba(var(--borderColorRGBA), 10%);\n\n  background-color: var(--darkColor) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
